export default __webpack_public_path__ + "static/media/curriculum_icon.c11b8271.svg";